<div class="row">
  <div class="col col-12">
    <app-header />
  </div>
</div>

@if (patient0() && activite) {
  <div class="row">
    <div class="col col-12 col-md-7 col-lg-8">
      <app-infos-patient-card [patient]="patient0()" [activite]="activite" />
    </div>

    <div class="col col-12 col-md-5 col-lg-4">
      <app-prescription-list-card
        [patient]="patient0()"
        [activite]="activite"
        (formCompleted)="loadPatientData()"
      />
    </div>
  </div>

  <div class="row">
    <div class="col col-12 col-md-7 col-lg-8">
      <app-traitement-card [patient]="patient0()" [activite]="activite" />
    </div>
    <div class="col col-12 col-md-5 col-lg-4">
      <app-materiel-list-card [patient]="patient0()" [activite]="activite" />
    </div>
  </div>

  @if (patient0()!.telesuivi?.observanceList) {
    <div class="row">
      <div class="col col-12">
        <app-telesuivi-card [patient]="patient0()!" />
      </div>
    </div>
  }

  <div class="row">
    <div class="col col-12">
      <app-intervention-list-card [patient]="patient0()" />
    </div>
  </div>
} @else {
  <div class="row placeholder">
    <div class="col col-12 col-md-7 col-lg-8">
      <app-infos-patient-card />
    </div>

    <div class="col col-12 col-md-5 col-lg-4">
      <app-prescription-list-card activite="" />
    </div>
  </div>

  <div class="row">
    <div class="col col-12 col-md-7 col-lg-8">
      <app-traitement-card />
    </div>
    <div class="col col-12 col-md-5 col-lg-4">
      <app-materiel-list-card />
    </div>
  </div>

  <div class="row">
    <div class="col col-12">
      <app-intervention-list-card />
    </div>
  </div>
}
